module.exports = __webpack_public_path__ + "static/media/artezio-logo.07b808b5.svg";